import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import AppContent from './AppContent';
import { AuthProvider } from './providers/auth';
import ScrollToTop from './utils/ScrollToTop';
import { ModalManagementProvider } from './providers/modal-manager';

function App() {
  return (
    <div>
      <Router>
        <ScrollToTop />
        <ModalManagementProvider>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </ModalManagementProvider>
      </Router>
    </div>
  );
}

export default App;
